/* Créé par Incipit Studio — défilement KAARZ */
(() => {
  'use strict';

  const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!desktopPointer.matches || (window.Shopify && window.Shopify.designMode)) return;
  if (typeof window.Lenis !== 'function' || window.kaarzLenis) return;

  const lenis = new window.Lenis({
    autoRaf: true,
    autoToggle: true,
    anchors: true,
    allowNestedScroll: true,
    stopInertiaOnNavigate: true,
    duration: 1.05,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
  });

  window.kaarzLenis = lenis;

  // If the pointer mode changes without a page reload, retain native scrolling.
  const onPointerChange = (event) => {
    if (event.matches) lenis.start();
    else lenis.stop();
  };
  desktopPointer.addEventListener('change', onPointerChange);
})();
